/* This file is automatically generated! Changes will be overwritten. */

export const colors = {
  white950: '#ffffff',
  white900: 'rgba(255, 255, 255, 0.9)',
  white800: 'rgba(255, 255, 255, 0.8)',
  white700: 'rgba(255, 255, 255, 0.7)',
  white600: 'rgba(255, 255, 255, 0.6)',
  white500: 'rgba(255, 255, 255, 0.5)',
  white400: 'rgba(255, 255, 255, 0.4)',
  white300: 'rgba(255, 255, 255, 0.3)',
  white200: 'rgba(255, 255, 255, 0.2)',
  white100: 'rgba(255, 255, 255, 0.1)',
  white50: 'rgba(255, 255, 255, 0.05)',
  black950: '#040506',
  black900: 'rgba(4, 5, 6, 0.9)',
  black800: 'rgba(4, 5, 6, 0.8)',
  black700: 'rgba(4, 5, 6, 0.7)',
  black600: 'rgba(4, 5, 6, 0.6)',
  black500: 'rgba(4, 5, 6, 0.5)',
  black400: 'rgba(4, 5, 6, 0.4)',
  black300: 'rgba(4, 5, 6, 0.3)',
  black200: 'rgba(4, 5, 6, 0.2)',
  black100: 'rgba(4, 5, 6, 0.1)',
  black50: 'rgba(4, 5, 6, 0.05)',
  grey950: '#040506',
  grey900: '#1F2126',
  grey800: '#2B2E35',
  grey700: '#43454B',
  grey600: '#55575D',
  grey500: '#70737B',
  grey400: '#A1A3A9',
  grey300: '#D3D4D8',
  grey200: '#E6E7E9',
  grey100: '#F4F4F5',
  grey50: '#FAFAFA',
  brand950: '#1F003B',
  brand900: '#2E0057',
  brand800: '#4C008F',
  brand700: '#6A00C7',
  brand600: '#8800FF',
  brand500: '#9A3BFF',
  brand400: '#AF73FF',
  brand300: '#C8A6FF',
  brand200: '#DECDFF',
  brand100: '#EEE4FF',
  brand50: '#F5F0FF',
  blue950: '#172554',
  blue900: '#1E3A8A',
  blue800: '#1E40AF',
  blue700: '#1D4ED8',
  blue600: '#2563EB',
  blue500: '#3B82F6',
  blue400: '#60A5FA',
  blue300: '#93C5FD',
  blue200: '#BFDBFE',
  blue100: '#DBEAFE',
  blue50: '#EFF6FF',
  orange950: '#4B1004',
  orange900: '#882814',
  orange800: '#A5280F',
  orange700: '#C82D0D',
  orange600: '#ED3915',
  orange500: '#FF6647',
  orange400: '#FF7E64',
  orange300: '#FFAE9D',
  orange200: '#FFCFC5',
  orange100: '#FFE4DF',
  orange50: '#FFF3F1',
  green950: '#03301D',
  green900: '#0F583A',
  green800: '#0F6C45',
  green700: '#0F8655',
  green600: '#09B06B',
  green500: '#20DF8F',
  green400: '#4CE5A6',
  green300: '#87EEC3',
  green200: '#BDF5DE',
  green100: '#DEFAEE',
  green50: '#F0FDF8',
  yellow950: '#461901',
  yellow900: '#7B3306',
  yellow800: '#973C00',
  yellow700: '#BB4D00',
  yellow600: '#E17100',
  yellow500: '#FE9A00',
  yellow400: '#FFB900',
  yellow300: '#FFD230',
  yellow200: '#FEE685',
  yellow100: '#FEF3C6',
  yellow50: '#FFFBEB',
  red950: '#48070C',
  red900: '#841821',
  red800: '#9F1521',
  red700: '#C11422',
  red600: '#E51A2B',
  red500: '#F83B4B',
  red400: '#FF6A76',
  red300: '#FFA1A9',
  red200: '#FFC7CC',
  red100: '#FFE1E4',
  red50: '#FFF1F2',
  pink950: '#4F033C',
  pink900: '#771860',
  pink800: '#911775',
  pink700: '#B21992',
  pink600: '#D623B3',
  pink500: '#F243D4',
  pink400: '#FB5FE1',
  pink300: '#FEA9F2',
  pink200: '#FFCFFA',
  pink100: '#FFE8FD',
  pink50: '#FFF4FE',
  purple15: '#500052',
  purple25: '#770079',
  purple35: '#8E2390',
  purple50: '#BB58BC',
  purple60: '#CC73CE',
  purple80: '#E7B7E7',
  purple95: '#FEF5FE',
  lightBlue00: '#7E96B2',
  transparent0: 'rgba(0,0,0,0)',
  transparent5: 'rgba(4, 5, 6, 0.05)',
  transparent10: 'rgba(4, 5, 6, 0.1)',
  black0t32: 'color-mix(in srgb, #040506, transparent 68%)',
  bgDefault: 'var(--bg-default)',
  bgSubtle: 'var(--bg-subtle)',
  bgOverlay: 'var(--bg-overlay)',
  bgInverted: 'var(--bg-inverted)',
  bgInvertedSubtle: 'var(--bg-inverted-subtle)',
  surfaceDefault: 'var(--surface-default)',
  surfaceDefaultSubtle: 'var(--surface-default-subtle)',
  surfaceHover: 'var(--surface-hover)',
  surfaceSelected: 'var(--surface-selected)',
  surfaceDisabled: 'var(--surface-disabled)',
  surfaceActive: 'var(--surface-active)',
  surfaceActiveHover: 'var(--surface-active-hover)',
  surfaceInverted: 'var(--surface-inverted)',
  surfaceInvertedSubtle: 'var(--surface-inverted-subtle)',
  surfaceInvertedHover: 'var(--surface-inverted-hover)',
  surfaceInvertedSelected: 'var(--surface-inverted-selected)',
  surfaceInvertedDisabled: 'var(--surface-inverted-disabled)',
  surfaceInvertedActive: 'var(--surface-inverted-active)',
  surfaceActionPrimary: 'var(--surface-action-primary)',
  surfaceActionPrimaryHover: 'var(--surface-action-primary-hover)',
  surfaceActionPrimaryPressed: 'var(--surface-action-primary-pressed)',
  surfaceActionPrimaryFocused: 'var(--surface-action-primary-focused)',
  surfaceActionPrimaryDisabled: 'var(--surface-action-primary-disabled)',
  surfaceActionPrimarySelected: 'var(--surface-action-primary-selected)',
  surfaceActionSecondary: 'var(--surface-action-secondary)',
  surfaceActionSecondaryHover: 'var(--surface-action-secondary-hover)',
  surfaceActionSecondaryPressed: 'var(--surface-action-secondary-pressed)',
  surfaceActionSecondaryFocused: 'var(--surface-action-secondary-focused)',
  surfaceActionSecondaryDisabled: 'var(--surface-action-secondary-disabled)',
  surfaceActionSecondarySelected: 'var(--surface-action-secondary-selected)',
  surfaceActionTertiary: 'var(--surface-action-tertiary)',
  surfaceActionTertiaryHover: 'var(--surface-action-tertiary-hover)',
  surfaceActionTertiaryPressed: 'var(--surface-action-tertiary-pressed)',
  surfaceActionTertiaryFocused: 'var(--surface-action-tertiary-focused)',
  surfaceActionTertiaryDisabled: 'var(--surface-action-tertiary-disabled)',
  surfaceActionTertiarySelected: 'var(--surface-action-tertiary-selected)',
  surfaceActionGhost: 'var(--surface-action-ghost)',
  surfaceActionGhostHover: 'var(--surface-action-ghost-hover)',
  surfaceActionGhostPressed: 'var(--surface-action-ghost-pressed)',
  surfaceActionGhostFocused: 'var(--surface-action-ghost-focused)',
  surfaceActionGhostDisabled: 'var(--surface-action-ghost-disabled)',
  surfaceActionGhostSelected: 'var(--surface-action-ghost-selected)',
  surfaceActionDelete: 'var(--surface-action-delete)',
  surfaceActionDeleteHover: 'var(--surface-action-delete-hover)',
  surfaceActionDeletePressed: 'var(--surface-action-delete-pressed)',
  surfaceActionDeleteFocused: 'var(--surface-action-delete-focused)',
  surfaceActionDeleteDisabled: 'var(--surface-action-delete-disabled)',
  surfaceActionDeleteSelected: 'var(--surface-action-delete-selected)',
  surfaceActionBrand: 'var(--surface-action-brand)',
  surfaceActionBrandHover: 'var(--surface-action-brand-hover)',
  surfaceActionBrandPressed: 'var(--surface-action-brand-pressed)',
  surfaceActionBrandFocused: 'var(--surface-action-brand-focused)',
  surfaceActionBrandDisabled: 'var(--surface-action-brand-disabled)',
  surfaceActionBrandSelected: 'var(--surface-action-brand-selected)',
  surfaceStatusNeutral: 'var(--surface-status-neutral)',
  surfaceBrand: 'var(--surface-brand)',
  surfaceBrandStrong: 'var(--surface-brand-strong)',
  surfaceInfo: 'var(--surface-info)',
  surfaceInfoStrong: 'var(--surface-info-strong)',
  surfaceSuccess: 'var(--surface-success)',
  surfaceSuccessStrong: 'var(--surface-success-strong)',
  surfaceWarning: 'var(--surface-warning)',
  surfaceError: 'var(--surface-error)',
  surfaceScenario: 'var(--surface-scenario)',
  textDefault: 'var(--text-default)',
  textModerate: 'var(--text-moderate)',
  textSubtle: 'var(--text-subtle)',
  textDisabled: 'var(--text-disabled)',
  textOnInverted: 'var(--text-on-inverted)',
  textOnInvertedSubtle: 'var(--text-on-inverted-subtle)',
  textOnInvertedStrong: 'var(--text-on-inverted-strong)',
  textOnInvertedDisabled: 'var(--text-on-inverted-disabled)',
  textAction: 'var(--text-action)',
  textActionHover: 'var(--text-action-hover)',
  textActionPressed: 'var(--text-action-pressed)',
  textActionDisabled: 'var(--text-action-disabled)',
  textBrand: 'var(--text-brand)',
  textBrandLight: 'var(--text-brand-light)',
  textInfo: 'var(--text-info)',
  textSuccess: 'var(--text-success)',
  textWarning: 'var(--text-warning)',
  textError: 'var(--text-error)',
  icon: 'var(--icon)',
  iconStrong: 'var(--icon-strong)',
  iconOnInverted: 'var(--icon-on-inverted)',
  iconOnInvertedStrong: 'var(--icon-on-inverted-strong)',
  iconOnInvertedSubtle: 'var(--icon-on-inverted-subtle)',
  iconAction: 'var(--icon-action)',
  iconActionHover: 'var(--icon-action-hover)',
  iconActionDisabled: 'var(--icon-action-disabled)',
  iconActionActive: 'var(--icon-action-active)',
  iconActionActiveHover: 'var(--icon-action-active-hover)',
  iconActionActiveDisabled: 'var(--icon-action-active-disabled)',
  iconActionBrand: 'var(--icon-action-brand)',
  iconActionBrandHover: 'var(--icon-action-brand-hover)',
  iconActionBrandDisabled: 'var(--icon-action-brand-disabled)',
  iconBrand: 'var(--icon-brand)',
  iconInfo: 'var(--icon-info)',
  iconSuccess: 'var(--icon-success)',
  iconWarning: 'var(--icon-warning)',
  iconError: 'var(--icon-error)',
  borderSubtle: 'var(--border-subtle)',
  borderFocus: 'var(--border-focus)',
  borderAction: 'var(--border-action)',
  borderActionHover: 'var(--border-action-hover)',
  borderActionActive: 'var(--border-action-active)',
  borderActionDisabled: 'var(--border-action-disabled)',
  borderBrand: 'var(--border-brand)',
  borderBrandStrong: 'var(--border-brand-strong)',
  borderNeutral: 'var(--border-neutral)',
  borderInfo: 'var(--border-info)',
  borderInfoStrong: 'var(--border-info-strong)',
  borderSuccess: 'var(--border-success)',
  borderSuccessStrong: 'var(--border-success-strong)',
  borderWarning: 'var(--border-warning)',
  borderWarningStrong: 'var(--border-warning-strong)',
  borderError: 'var(--border-error)',
  borderErrorStrong: 'var(--border-error-strong)',
  borderDisabled: 'var(--border-disabled)',
  componentSwitchSurfaceDefault: 'var(--component-switch-surface-default)',
  componentSegmentedControlSurfaceDefault:
    'var(--component-segmented-control-surface-default)',
};
